/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { FormElems, Alert } from '../../components';
import { validators } from '../../utils/validators';
import { excludedUserLevels, UNIFIED_MSR } from './constant';

const DownloadFile = props => {
    const {
        actions,
        filterData,
        showDownloadPopup,
        setShowDownloadPopup,
        tableData,
        handleSubmit,
        untouch,
        change,
        generateData,
        isDateRangeFieldRequired,
        dateRangeFieldName,
        userLevel,
        auth,
    } = props;

    const IS_EDI_REPORT =
        filterData && filterData.settlementMode === 'EDI_TRANSACTION';

    const handleOpenActionPopup = actionType => {
        setShowDownloadPopup(!showDownloadPopup);
    };

    useEffect(() => {
        if (generateData.isSuccess) {
            change('fileName', '');
            untouch('downloadFile', 'fileName');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [generateData.isSuccess]);

    const handleCloseOpenActionPopup = () => {
        setShowDownloadPopup(false);
        change('fileName', '');
        untouch('downloadFile', 'fileName');
    };

    const handleGenerateSubmit = values => {
        let startDateTime, endDateTime;
        const startDate = moment(filterData.startDate);
        const endDate = moment(filterData.endDate);
        if (startDate.isSame(endDate, 'day')) {
            // If both dates are the same, set startDateTime to 00:00:01 of that day
            startDateTime = startDate.startOf('day').add(1, 'second').format('YYYY-MM-DD HH:mm:ss');
            endDateTime = endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss');
        } else {
            // Normal case
            startDateTime = startDate.startOf('day').format('YYYY-MM-DD HH:mm:ss');
            endDateTime = endDate.endOf('day').format('YYYY-MM-DD HH:mm:ss');
        }

                const payload = {
            msrReportMetadata: {
                entityName:
                    Array.isArray(filterData?.entityNames) &&
                    filterData.entityNames.length > 0
                        ? filterData?.entityNames[0]
                        : null,
                entityID:
                    Array.isArray(filterData?.entityIds) &&
                    filterData.entityIds.length > 0
                        ? filterData?.entityIds[0]
                        : auth.userDetails.associatedEntityId,
                merchantIds:
                    Array.isArray(filterData?.entityIds) &&
                    filterData.entityIds.length > 0
                        ? [filterData?.entityIds[0]]
                        : [],
            },
            aggregatorId: filterData?.aggregatorId,
            aggregatorId: filterData?.aggregatorId,
            merchantIds:
                Array.isArray(filterData?.entityIds) &&
                filterData.entityIds.length > 0
                    ? [filterData?.entityIds[0]]
                    : [],
            startDateTime: startDateTime,
            endDateTime: endDateTime,
            reportType: IS_EDI_REPORT ? 'EDI_REPORT' : UNIFIED_MSR,
            reportFileName:
                userLevel === 'AGGREGATOR'
                    ? `${IS_EDI_REPORT ? 'EDI_REPORT_' : 'UNIFIED_MSR_'}${filterData?.aggregatorId}`
                    : userLevel !== 'MERCHANT'
                        ? `${IS_EDI_REPORT ? 'EDI_REPORT_' : 'UNIFIED_MSR_'}${filterData?.entityIds[0]}`
                        : `${IS_EDI_REPORT ? 'EDI_REPORT_' : 'UNIFIED_MSR_'}${auth.userDetails.associatedEntityId}`
        };

        userLevel === 'AGGREGATOR'
            ? payload.msrReportMetadata = null
            : payload.aggregatorId = null;

        actions.generateReportRequest(payload);
    };

    const isDownloadButtonDisabled = () => {
        if (IS_EDI_REPORT) {
            return false;
        }

        if(!IS_EDI_REPORT && userLevel === 'AGGREGATOR')
        {
            return true;
        }
       
        let isDisabled = false;
        if (tableData.length === 0) {
            isDisabled = true;
        }

        // Matching End Date Timestamp from start Time ie. 00:00:00 with real time timestamp start time

        const endDate = filterData.endDate;

        const endDateTimestamp = moment(endDate)
            .startOf('day')
            .unix();

        const realtime = moment(new Date())
            .startOf('day')
            .unix();

        // if (endDateTimestamp === realtime) {
        //     isDisabled = true;
        // }

        return isDisabled;
    };

    const isMultipleMerchantsSelected = () => {
        const selectedMerchants = filterData?.entityIds || [];
        return selectedMerchants.length > 1;
    };

    useEffect(() => {
        return () => {
            handleCloseOpenActionPopup();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isGenerateButtonDisabled = () => {
        const isMultipleMerchant = isMultipleMerchantsSelected();
        if(userLevel === 'AGGREGATOR')
        {
            return isMultipleMerchant
        }
        if (userLevel !== 'MERCHANT') {
            const isDateRangeField = isDateRangeFieldRequired
                ? isEmpty(filterData[dateRangeFieldName])
                : false;
            return isMultipleMerchant || isDateRangeField;
        }
        if (IS_EDI_REPORT) {
            
            return false;
        }
        if (isEmpty(tableData)) {
            
            return true;
        }
        
    };

    return (
        <div className="download-popup">
            <button
                className={`download ${showDownloadPopup ? 'active' : ''} ${
                    isDownloadButtonDisabled() ? 'disable-download' : ''
                } testclass`}
                onClick={handleOpenActionPopup}
                disabled={isDownloadButtonDisabled()}
            />
            {showDownloadPopup ? (
                <>
                    <div
                        className="overlay"
                        onClick={handleCloseOpenActionPopup}
                    />
                    <div className="popup-download">
                        <div className="content-body">
                            <form
                                className="popup-download-edit"
                                onSubmit={handleSubmit(handleGenerateSubmit)}
                            >
                                {isMultipleMerchantsSelected() && (
                                    <Alert customClass="error-msg">
                                        Multiple merchants selected, please
                                        select only one merchant
                                    </Alert>
                                )}
                                {!excludedUserLevels.includes(userLevel) &&
                                isEmpty(filterData[dateRangeFieldName]) ? (
                                    <Alert customClass="error-msg">
                                       Please select a merchant
                                    </Alert>
                                ) : isEmpty(tableData) && !IS_EDI_REPORT ? (
                                    <Alert customClass="error-msg">
                                        No data available
                                    </Alert>
                                ) : userLevel !== 'MERCHANT' &&
                                  isEmpty(filterData.merchantId) ? (
                                    // <Alert customClass="error-msg">
                                    //     Please Select Merchant Id
                                    // </Alert>
                                    <></>
                                ) : null}
                                <div className="form-section action">
                                    <FormElems.Button
                                        buttonType="primary"
                                        text="Generate"
                                        isDisable={isGenerateButtonDisabled()}
                                    />
                                </div>
                            </form>
                        </div>
                    </div>
                </>
            ) : null}
        </div>
    );
};

DownloadFile.propTypes = {
    actions: PropTypes.object,
    filterData: PropTypes.object,
    tableData: PropTypes.object,
    showDownloadPopup: PropTypes.bool,
    setShowDownloadPopup: PropTypes.func,
    handleSubmit: PropTypes.func,
    change: PropTypes.func,
    untouch: PropTypes.func,
    generateData: PropTypes.object,
    isDateRangeFieldRequired: PropTypes.bool,
    dateRangeFieldName: PropTypes.string,
    userLevel: PropTypes.string,
    auth: PropTypes.object,
};

const validate = values => {
    const { REQUIRED } = validators;
    const errors = {};

    // if (REQUIRED(values) || REQUIRED(values.fileName)) {
    //     errors.fileName = 'Please enter a File Name';
    // }
    // if (values.fileName && values.fileName.length > 25) {
    //     errors.fileName = 'Max 25 character are allowed in filename';
    // }
    // const isValid = /^[A-Za-z0-9\d\-_\s]+$/i.test(values.fileName);
    // if (!isValid) {
    //     errors.fileName =
    //         'Only numbers, letters, - & _ are allowed in filename';
    // }
    // if (!/^\S+$/.test(values.fileName)) {
    //     errors.fileName = 'Spaces not allowed in filename';
    // }
    return errors;
};

export default reduxForm({
    form: 'downloadFile',
    enableReinitialize: true,
    validate,
    destroyOnUnmount: false,
})(DownloadFile);
